var _polygon, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135.14px",
    height: "47.63px",
    viewBox: "0 0 135.14 47.63",
    enableBackground: "new 0 0 135.14 47.63",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#042b62",
    points: "32.811,28.889 32.85,28.811 37.83,20.471 22.347,20.471 19.877,17.383 39.645,17.42 45.591,7.421  2,7.537 24.007,43.713 29.915,33.714 27.328,28.889 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M53.852,19.583h-4.929v3.429h4.53v2.552h-4.53v5.426h-3.146V17.022h8.075V19.583z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M62.467,30.99h-3.146V17.022h3.146V30.99z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M81.383,30.99h-3.176l-5.758-8.776c-0.336-0.513-0.57-0.899-0.701-1.159h-0.039 c0.053,0.494,0.078,1.247,0.078,2.26v7.676h-2.97V17.022h3.39l5.543,8.503c0.252,0.383,0.486,0.764,0.701,1.141h0.039 c-0.053-0.325-0.078-0.965-0.078-1.919v-7.725h2.971V30.99z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M97.557,19.583h-3.982V30.99h-3.156V19.583h-3.965v-2.562h11.104V19.583z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M107.775,31.233c-2,0-3.631-0.65-4.891-1.953c-1.26-1.302-1.889-2.998-1.889-5.089 c0-2.208,0.639-3.994,1.918-5.357s2.975-2.045,5.086-2.045c1.992,0,3.605,0.653,4.836,1.958s1.846,3.026,1.846,5.163 c0,2.195-0.639,3.964-1.914,5.309C111.492,30.562,109.828,31.233,107.775,31.233z M107.912,19.496c-1.104,0-1.98,0.414-2.631,1.242 c-0.648,0.828-0.973,1.924-0.973,3.288c0,1.383,0.324,2.478,0.973,3.283c0.65,0.805,1.5,1.207,2.553,1.207 c1.084,0,1.945-0.391,2.582-1.174c0.635-0.782,0.953-1.868,0.953-3.258c0-1.448-0.309-2.575-0.924-3.38 C109.828,19.899,108.982,19.496,107.912,19.496z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M126.07,31.233c-2,0-3.631-0.65-4.891-1.953c-1.26-1.302-1.889-2.998-1.889-5.089 c0-2.208,0.639-3.994,1.918-5.357s2.975-2.045,5.086-2.045c1.992,0,3.605,0.653,4.836,1.958s1.846,3.026,1.846,5.163 c0,2.195-0.639,3.964-1.914,5.309C129.787,30.562,128.123,31.233,126.07,31.233z M126.207,19.496c-1.104,0-1.98,0.414-2.631,1.242 c-0.648,0.828-0.973,1.924-0.973,3.288c0,1.383,0.324,2.478,0.973,3.283c0.65,0.805,1.5,1.207,2.553,1.207 c1.084,0,1.945-0.391,2.582-1.174c0.635-0.782,0.953-1.868,0.953-3.258c0-1.448-0.309-2.575-0.924-3.38 C128.123,19.899,127.277,19.496,126.207,19.496z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a81ddd88e7299ca3274f75330bb5f627.svg";
export { ForwardRef as ReactComponent };